import request from '@/utils/httpRequest'

export default class SwitchService {
    queryById(id) {
        return request({
            url: '/shye/daily/shyeSwitchRoom/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow (params) {
        return request({
            url: '/shye/daily/shyeSwitchRoom/startFlow',
            method: 'post',
            data: params
        })
    }

}
